import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { Star, Heart, ChevronDown } from "lucide-react";
import { useState } from "react";

export const TestimonialsSection = () => {
  const [showMore, setShowMore] = useState(false);

  const testimonials = [
    {
      initials: "RS",
      name: "Ritu Sharma",
      text: "Life Journey Report ने मेरी career direction clear कर दी। Remedies आसान और effective हैं।"
    },
    {
      initials: "AV",
      name: "Anil Verma", 
      text: "Marriage decisions में clarity मिली। Report detailed और accurate थी।"
    },
    {
      initials: "MK",
      name: "Meena Kapoor",
      text: "Financial stability के लिए जो solutions दिए, उन्होंने सच में काम किया।"
    },
    {
      initials: "SM",
      name: "Sanjay Mehta",
      text: "Report पढ़कर लगा जैसे मेरे दिल की बात लिखी हो। Career और health दोनों पर सही guidance मिली।"
    },
    {
      initials: "PM",
      name: "Priya Malhotra",
      text: "Remedies follow करना बहुत आसान था और असर भी जल्दी दिखा। Confidence level बढ़ गया है।"
    },
    {
      initials: "RK",
      name: "Rahul Khanna",
      text: "Transit pblueictions बिलकुल accurate रहे। Business decisions लेने में बहुत मदद मिली।"
    },
    {
      initials: "NG",
      name: "Neha Gupta",
      text: "पहली बार astrology इतनी practical लगी। Report simple language में थी और समझना आसान था।"
    },
    {
      initials: "VS",
      name: "Vikram Sood",
      text: "Family और relationships के बारे में जो insights मिले, उन्होंने मेरी life बदल दी। Highly recommended!"
    },
    {
      initials: "AK",
      name: "Aarti Kumar",
      text: "Report में जो remedies दी गईं, उन्होंने मेरे जीवन में positivity और balance लाया।"
    }
  ];

  const visibleTestimonials = showMore ? testimonials : testimonials.slice(0, 3);

  return (
    <section className="bg-gradient-to-b from-cosmic-blue/10 to-background-blue">
      <div className="container mx-auto px-6 pt-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Heart className="w-16 h-16 text-cosmic-gold mx-auto mb-6" />
          <h2 className="text-sm uppercase tracking-wider text-cosmic-gold mb-4">TESTIMONIALS</h2>
          <h3 className="text-4xl lg:text-5xl font-bold text-foreground">
            Loved by thousands!
          </h3>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {visibleTestimonials.map((testimonial, index) => (
            <Card key={index} className="p-6 border-cosmic-gold/20 bg-card-blue/50 backdrop-blur-sm hover:shadow-[0_0_20px_hsl(var(--mystic-gold)/0.2)] transition-all duration-300">
              {/* Rating Stars */}
              <div className="flex space-x-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star key={star} className="w-4 h-4 fill-cosmic-gold text-cosmic-gold" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-muted-foreground mb-6 text-sm leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3">
                <Badge className="w-10 h-10 rounded-full bg-gradient-to-b from-cosmic-gold to-cosmic-gold-dark text-primary-foreground font-bold flex items-center justify-center">
                  {testimonial.initials}
                </Badge>
                <div>
                  <div className="font-semibold text-foreground">{testimonial.name}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Show More Button */}
        {!showMore && (
          <div className="text-center">
            <Button 
              variant="cosmic-outline" 
              onClick={() => setShowMore(true)}
              className="group"
            >
              Show More
              <ChevronDown className="w-4 h-4 ml-2 group-hover:translate-y-1 transition-transform" />
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};